<template>
  <div class="">
    <div class="flex justify-between">
      <inline-tab-header
          :headers="filterHeaders"
          name="Filter By"
          :current="activeHeaderFilter"
          @update:current="updateCurrentFilter"
      ></inline-tab-header>
    </div>

    <!-- Table -->
    <ajax-table :data="data"
                :headers="headers"
                v-model:loading="ajaxTable.loading"
                v-model:search="ajaxTable.search"
                v-model:sort-by="ajaxTable.sortBy"
                v-model:sort-desc="ajaxTable.sortDesc"
                v-model:page="ajaxTable.page"
                v-model:items-per-page="ajaxTable.itemsPerPage"
                v-model:page-info="ajaxTable.pageInfo"
                v-model:noDataMessage="noDataMessage"
                :exportable="false"
                @loadData="getData"
    >

      <template #above_table_center>
        <div
          class="hidden md:flex flex-shrink-0 py-1.5 my-2 xl:w-2/3 items-center rounded-md border border-solid border-blue-500 cursor-pointer">
          <download-excel
            :fetch="exportData"
            :fields="csvFields"
            :name="csvFilename"
            extra-classes="w-full"
            type="csv">
            <div class="flex">
              <div class="pr-2">
                <span class="lnr icon-download2 cursor-pointer pl-2 text-gray-500 hover:text-gray-700"></span>
              </div>
              <div class="px-2 py-1 border-l border-solid border-blue-500 rounded-r-md grow">
                <span v-if="exporting"
                      class="flex items-center text-gray-800">
                  <span :class="iconLoading"></span>
                  <span>Exporting</span>
                </span>
                <span v-else class="text-gray-800">Download CSV</span>
              </div>
            </div>
          </download-excel>
        </div>
      </template>

      <!-- Column 1: Name-->
      <template #col-1="props">
        <div    class="flex flex-col items-start justify-center">
              <span
                  class="my-1 text-gray-700"
                  @click="viewMeterLink(props.row.id)">
                  {{ props.row.name }}
              </span>
          <span
              class="text-sm leading-5 text-gray-500"
              @click="viewEditMeterLink(props.row.id)">
                        {{ props.row.serial_number }}
                    </span>

        </div>
      </template>

      <!-- Column 2: Location-->
      <template #col-2="props">
        <div    class="flex flex-col items-start justify-center">
          <span
              class="my-1 text-gray-700"
              @click="viewEditAreaLink(props.row.area_id)">
                        {{ props.row.zone.area.Name }}
                    </span>

          <span   class="text-sm leading-5 text-gray-500"
                  @click="viewEditZoneLink(props.row.zone_id)">
                        {{ props.row.zone.Name }}
                    </span>

        </div>
      </template>

      <!-- Column 3: Last Reading -->
      <template #col-3="props">
        <div    class="flex flex-col items-start justify-center">
          <span   class="px-2 my-2 rounded-full"
                  :class="getIndicatorColor(props.row.level)">
                                {{ props.row.last_reading || "Offline" }}
                            </span>



          <span   class="text-sm leading-5 text-gray-500">
                  {{ props.row.last_update_time_diff }}
              </span>

        </div>
      </template>

      <!-- Column 4: Diagnostics -->
      <template #col-4="props">
        <div    class="grid grid-cols-4">
            <battery-percent-icon
                v-bind="props.row.battery_percent"
                v-if="props.row.battery_percent"
                :id="props.row.id"
                :batteryPercent="props.row.battery_percent"
                :powerOk="props.row.power_status"
                >
            </battery-percent-icon>
            <span class="px-2 col-span-3" v-if="props.row.battery_percent">{{props.row.battery_percent}}%</span>
            <span class="col-span-4 text-sm text-gray-500"
                  v-if="props.row.power_status === false && props.row.battery_percent">
              On Battery</span>
              <signal-strength-icon
                  v-if="props.row.signal_strength"
                  v-bind="props.row.signal_strength_percent"
                  :id="props.row.id"
                  :signalStrength="parseInt(props.row.signal_strength_percent)"
                  :radioType="props.row.radio_type"
              ></signal-strength-icon>
              <span
                  v-if="props.row.signal_strength"
                  class="col-span-3 px-2 ">
                 {{ props.row.signal_strength}}dB</span>
              <signal-noise-ratio-icon
                v-if="props.row.signalNoiseRatio"
                v-bind="props.row.signalNoiseRatio"
                :id="props.row.id"
                :signalNoiseRatio="parseInt(props.row.signal_strength)"
              >
              </signal-noise-ratio-icon>
              <span
                  v-if="props.row.signalNoiseRatio"
                  class="col-span-3"
              >{{props.row.signal_noise_ratio}}%</span>
        </div>
      </template>

      <!-- Column 5: Alarms-->
      <template #col-5="props">
        <div>
          <span
              class="px-2 my-2"
              v-if="!props.row.alarm_profile.threshold_alarms_enabled
          && !props.row.alarm_profile.offline_alarms_enabled">
            No Alarms Configured
           </span>
          <div
              class="bg-red-100 px-2 my-2 rounded-full text-center"
              v-for="(alarm) in props.row.alarms_not_resolved"
              @click="viewAlarmLink(alarm.AlarmID)"
          >
            {{getAlarmTypeText(alarm.AlarmType)}}
           </div>
          <div
              @click="viewAlarmProfileLink(props.row.alarm_profile.id)"
              class="bg-green-100 px-2 my-2 rounded-full text-center"
              v-if="checkThresholdAlarmsOK(props.row)">
           Threshold Alarm OK
           </div>
          <div
              @click="viewAlarmProfileLink(props.row.alarm_profile.id)"
              class="bg-green-100 px-2 my-2 rounded-full text-center"
              v-if="checkOfflineAlarmsOK(props.row)">
           Offline Alarm OK
           </div>

        </div>
      </template>

    </ajax-table>
  </div>
</template>
<script>

import axios from "axios"
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import Pagination from "@/components/Pagination"
import ItemsPerPageSelect from "@/components/ItemsPerPageSelect"
import FloatingInput from "@/components/elements/FloatingInput";
import AjaxTable from "@/components/elements/AjaxTable";
import {ajaxTableMixin} from "@/mixins/ajaxTableMixin";
import Loading from "@/components/elements/loading";
import SmallColoredCheck from "@/components/elements/SmallColoredCheck";
import {UrlParamsMixin} from "@/mixins/UrlParamsMixin";
import _ from "lodash";
import AlarmProfileEdit from "@/components/alarmProfiles/alarmProfilesEdit";
import JsonExcel from "@/components/JsonExcel.vue";

export default {
  name: "CurrentDataSummary",
  mixins: [SonicuCoreMixin, iconNamesMixin, ajaxTableMixin, UrlParamsMixin],
  components: {
    'download-excel': JsonExcel,
    SmallColoredCheck,
    AlarmProfileEdit,
    Loading, AjaxTable, Pagination, ItemsPerPageSelect, FloatingInput,
  },
  props: {
    extraFilter: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      data: [],
      headers: [
        {
          name: 'Name/Serial',
          sortBy: 'name',
          show: 'sm',
          key: 'name',
        },
        {
          name: 'Area/Zone',
          sortBy: 'area',
          show: 'sm',
          key: 'location',
        },
        {
          name: 'Last Reading',
          sortBy: '',
          show: 'md',
          key: 'reading',
        },
        {
          name: 'Diagnostics',
          sortBy: '',
          show: 'md',
          key: 'diagnostics',
        },
        {
          name: 'Alarms',
          sortBy: '',
          show: 'md',
          key: 'alarms',
        },
      ],
      filterHeaders: [
        {
          text: 'Non-Diagnostic Data',
          event: 'non-diag-data',
        },
        {
          text: 'Include Diagnostic Data',
          event: 'diag-data',
        },
      ],
      requestNumber: 0,

      activeHeaderFilter: null,
      showNonDiagOnly: true,
      showFilteredStatusOnly: false,
      noDataMessage: "No Data Found",
      csvFields: {
        "Area": "area_name",
        "Zone": "zone_name",
        "Name": "name",
        "Serial": "serial",
        "Last Reading": "last_reading", // TODO: This may need to handle offline
        "Last Reading Time": "last_update_time_diff",
        "Battery Percent": "battery_percent",
        "Power Status": "power_status",
        "Signal Strength": "signal_strength",
        "Signal Noise Ratio": "signal_noise_ratio",
        "Alarm Profile Name": "alarm_profile_name",
        "Threshold Alarms Enabled": "alarm_profile_threshold_alarms_enabled",
        "Offline Alarms Enabled": "alarm_profile_offline_alarms_enabled",
        "In Alarm?" : "in_alarm",
      },
      exporting: false,
    }
  },
  created() {
    this.ajaxTable.sortBy = 'name'

    if(this.extraFilter){
      this.filterHeaders.push(this.extraFilter)
      this.activeHeaderFilter = this.extraFilter['event']
    }
  },
  mounted() {
  },
  methods: {
    getData() {
      this.noDataMessage = "Updating Table..."
      this.ajaxTable.loading = true
      this.requestNumber++
      let params = JSON.parse(JSON.stringify(this.ajaxTable))
      params.requestNumber = this.requestNumber
      params.showNonDiagOnly = this.showNonDiagOnly
      params.showFilteredStatusOnly = this.showFilteredStatusOnly
      axios.get(this.company.buildCompanyApiInternalRoute('current-readings-report'),
          {
            params: params,
          }
      ).then(response => {
        console.log(response);
        let data = response.data.data;
        data.meta = {};
        data.meta.current_page = data.current_page;
        data.meta.from = data.from;
        data.meta.to = data.to;
        data.meta.path = data.path;
        data.meta.per_page = data.per_page;
        data.meta.last_page = data.last_page;
        data.meta.requestNumber = response.data.requestNumber;
        if (data.meta.requestNumber !== `${this.requestNumber}`) {
          return
        }
        this.ajaxUpdateTableData(data); // This sends the data to the mixin for AjaxTable
        this.data = !_.isNil(data.data) ? data.data : [];
        this.allData = this.data;
        if(this.data.length == 0){
          this.noDataMessage = "No Data Found";
        }
      }).catch(error => {
        console.log(error)
      }).then(() => {
        this.ajaxTable.loading = false
      })
    },
    getAlarmTypeText(alarmTypeInt){
      if(alarmTypeInt == 1){
        return "Active Threshold Alarm"
      }
      if(alarmTypeInt == 2){
        return "Active Offline Alarm"
      }
      else{
        return "Unknown Alarm Type"
      }
    },
    updateCurrentFilter(currentFilter) {
      this.page = 1
      this.activeHeaderFilter = currentFilter
      this.showNonDiagOnly = currentFilter === 'non-diag-data'
      this.showFilteredStatusOnly = currentFilter.includes('filter') ? currentFilter : null
      this.getData()
    },
    viewMeterLink(meterId) {
      if (!this.permissions.can('view_meter')) {
        return '#'
      }
      return window.location.href = this.company.buildCompanyRoute(`meters/${meterId}`)
    },
    viewEditMeterLink(meterId) {
      if (!this.permissions.can('edit_meter')) {
        return '#'
      }
      return window.location.href = this.company.buildCompanyRoute(`meters/${meterId}/edit`)
    },
    viewEditAreaLink(areaId) {
      if (!this.permissions.can('edit_area')) {
        return '#'
      }
      return window.location.href = this.company.buildCompanyRoute(`areas/${areaId}/edit`)
    },
    viewEditZoneLink(zoneId) {
      if (!this.permissions.can('edit_zone')) {
        return '#'
      }
      window.location.href = this.company.buildCompanyRoute(`zones/edit-zone?id=${zoneId}`)
    },
    viewAlarmLink(alarmId) {
      if (!this.permissions.can('update_alarms')) {
        return '#'
      }
      window.location.href = this.company.buildCompanyRoute(`alarms/${alarmId}`)
    },
    viewAlarmProfileLink(alarmProfileId) {
      if (!this.permissions.can('edit_alarm_profiles')) {
        return '#'
      }
      window.location.href = this.company.buildCompanyRoute(`alarm-profiles/${alarmProfileId}/edit`)
    },
    checkThresholdAlarmsOK(rowData){
      return rowData.alarm_profile.threshold_alarms_enabled && rowData.alarms_not_resolved.length == 0
    },
    checkOfflineAlarmsOK(rowData){
      return rowData.alarm_profile.offline_alarms_enabled && rowData.alarms_not_resolved.length == 0
    },
    getIndicatorColor(level){
      switch(level) {
        case 0:
          return 'bg-gray-100'
          break;
        case 1:
          return 'bg-green-100'
          break;
        case 2:
          return 'bg-yellow-100'
          break;
        case 3:
          return 'bg-red-100'
          break;
        default:
          break;
      }
    },
    async exportData() {
      this.exporting = true
      let params = {
        page: 1,
        itemsPerPage: this.ajaxTable.pageInfo.pages * this.ajaxTable.pageInfo.per_page,
        search: this.ajaxTable.search,
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
      }
      params.requestNumber = this.requestNumber
      params.showNonDiagOnly = this.showNonDiagOnly

      let newData = []
      const response = await axios.get(this.company.buildCompanyApiInternalRoute('current-readings-report'), {
        params: params
      })

      newData = response.data.data.data !== undefined ? response.data.data.data : []
      this.exporting = false

      return newData.map(row => {
        return {
          'area_name': row.zone.area.Name,
          'zone_name': row.zone.Name,
          'name': row.name,
          'serial': row.serial_number,
          'last_reading': row.last_reading || 'Offline',
          'last_update_time_diff': row.last_update_time_diff,
          'battery_percent': row.battery_percent > 0 ? row.battery_percent + '%' : 'N/A',
          'power_status': row.power_status ? 'Powered' : 'Battery',
          'signal_strength': row.signal_strength < -10 ? row.signal_strength + 'dB' : 'N/A',
          'signal_noise_ratio': row.signal_noise_ratio === null ? 'N/A' : row.signal_noise_ratio + 'dB',
          'alarm_profile_name': row.alarm_profile.name,
          'alarm_profile_threshold_alarms_enabled': row.alarm_profile.threshold_alarms_enabled ? 'Yes' : 'No',
          'alarm_profile_offline_alarms_enabled': row.alarm_profile.offline_alarms_enabled ? 'Yes' : 'No',
          'in_alarm': row.alarms_not_resolved.length === 0 ? ((row.alarm_profile.threshold_alarms_enabled || row.alarm_profile.offline_alarms_enabled) ? 'No Alarm' : 'N/A') : 'In Alarm',
        }
      })
    }
  },
  computed: {
    csvFilename(){
      return `${this.company.getCompanyId()}_summary_${moment().format('YYYYMMDDHHmmss')}.csv`
    }
  },
  watch: {
  },
}
</script>

<style scoped>

</style>